<p-dialog [(visible)]="visible" [modal]="true" [closable]="closed" [closeOnEscape]="closed" [draggable]="false" [dismissableMask]="false" [style]="{ width: '28rem' }" header="Importando Marcaciones">
    <div class="flex flex-col gap-3">
        @if (!finished && !failed) {
            <div class="text-center">
                <span>Importando marcaciones... {{ progress }}%</span>
            </div>
            <p-progressBar [value]="progress"></p-progressBar>
        } @else if (finished) {
            <div class="text-center">
                <span class="font-semibold text-green-600"><i class="pi pi-check-circle mr-2"></i>Importación completada</span>
            </div>
            <div class="text-sm text-muted-color text-center">{{ summaryText }}</div>
            <p-progressBar [value]="100"></p-progressBar>
        } @else {
            <div class="text-center">
                <span class="font-semibold text-red-600"><i class="pi pi-times-circle mr-2"></i>Error al importar</span>
            </div>
            <div class="text-sm text-muted-color text-center">{{ errorMsg }}</div>
        }
    </div>
    <ng-template #footer>
        @if (closed) {
            <button pButton type="button" label="Cerrar" icon="pi pi-check" (click)="closeModal()"></button>
        }
    </ng-template>
</p-dialog>
